module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ch-image"
  }, [_c('img', {
    staticClass: "ch",
    attrs: {
      "alt": "image",
      "src": "images/ch.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "bm-title"
  }, [_c('span', {
    staticClass: "r-bold"
  }, [_vm._v("Table of Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/fm02"
    }
  }, [_vm._v("Foreword by Kevin Harrington")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/fm03"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/fm04"
    }
  }, [_vm._v("Introduction by Brandon T. Adams")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/fm05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction by Samantha Rossin")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Chapter 1:")]), _vm._v(" Brandon T. Adams in Scottsdale, Arizona—Money, Power, and Fame Won’t Make You Happy!")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Chapter 2:")]), _vm._v(" Samantha Rossin in Scottsdale—Giving Your Time to Others")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Chapter 3:")]), _vm._v(" Brandon in Austin, Texas—Faith, Love, and Never Giving Up")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Chapter 4:")]), _vm._v(" Samantha in Austin—The Power of Choice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Chapter 5:")]), _vm._v(" Brandon—Accepting Change and Learning to Let Go")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Chapter 6:")]), _vm._v(" Brandon in Boston—Networking Like Pros and Meeting Boston Ballers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Chapter 7:")]), _vm._v(" Brandon—Giving Your Life Away for the Joy of Others")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Chapter 8:")]), _vm._v(" Brandon—Selling Everything and Our Next Chapter of the Show")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Chapter 9:")]), _vm._v(" Samantha in Denver—Your Story Matters")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Chapter 10:")]), _vm._v(" Samantha—My Story Matters")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Chapter 11:")]), _vm._v(" Brandon—Overcoming Obstacles")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Chapter 12:")]), _vm._v(" Samantha—The Wedding in Nashville")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Chapter 13:")]), _vm._v(" Brandon—Life after the Show")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Chapter 14:")]), _vm._v(" Brandon—The Road to the Emmys")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Chapter 15:")]), _vm._v(" Brandon—The Netflix Journey")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Chapter 16:")]), _vm._v(" Brandon—Where Would We Be If We Didn’t Pursue Our Dreams?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fmt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Afterthoughts from Brandon and Samantha")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno1"
  }, [_vm._v("Bonus Chapter:")]), _vm._v(" Kevin Harrington on Why Failure Is a Necessary Lesson")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Authors")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 72
// module chunks = 0